import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, Layers } from "lucide-react";
import api from "../lib/api";

const reveal = (delay) => ({
    initial: { opacity: 0, y: 36 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.15 },
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay },
});

export default function CollectionStrip() {
    const { data: collections } = useQuery({
        queryKey: ["collections"],
        queryFn: async () => (await api.get("/collections")).data,
    });

    if (!collections || collections.length === 0) return null;

    return (
        <section id="koleksi" className="scroll-mt-24 py-16 md:py-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div {...reveal(0)} className="flex flex-wrap items-end justify-between gap-6">
                    <div className="max-w-2xl">
                        <span className="inline-block px-3 py-1 rounded-full border-2 border-brand-ink bg-white text-[11px] font-extrabold uppercase tracking-[0.18em] shadow-hard-sm">Koleksi Kurasi</span>
                        <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">
                            Rangkaian Pilihan <span className="text-brand-forest">Acture.id</span>
                        </h2>
                        <p className="mt-3 text-slate-600">Karya yang dirangkai se-tema — satu tautan, siap kamu bagikan.</p>
                    </div>
                </motion.div>

                <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7 items-stretch">
                    {collections.slice(0, 3).map((c, i) => (
                        <motion.div key={c.id} {...reveal(0.08 * i)} whileHover={{ y: -6 }}>
                            <Link
                                to={`/koleksi/${c.id}`}
                                data-testid={`collection-card-${c.id}`}
                                className="group block rounded-[26px] border-2 border-brand-ink bg-white overflow-hidden shadow-hard-sm hover:shadow-hard transition-shadow"
                            >
                                <div className="relative aspect-[16/10] overflow-hidden">
                                    {c.products[0] ? (
                                        <img src={c.products[0].image} alt={c.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                                    ) : (
                                        <div className="w-full h-full grid place-items-center bg-brand-forestLight">
                                            <Layers className="w-10 h-10 text-brand-forest/50" />
                                        </div>
                                    )}
                                    <span className="absolute top-3.5 left-3.5 px-3 py-1 rounded-full border-2 border-brand-ink bg-brand-sunshine text-[11px] font-extrabold">
                                        {c.products.length} karya
                                    </span>
                                </div>
                                <div className="p-6">
                                    <h3 className="font-display text-xl font-bold flex items-center justify-between gap-2">
                                        {c.title}
                                        <ArrowUpRight className="w-5 h-5 shrink-0 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2.6} />
                                    </h3>
                                    {c.description && <p className="mt-2 text-sm text-slate-600 leading-relaxed line-clamp-2">{c.description}</p>}
                                </div>
                            </Link>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
